<template>
  <div class="tag-container">
    <BlogHeader  @search="handleSearchFromHeader" />

    <main class="main-content">
      <div class="tag-list-container">
        <h2 class="page-title">标签云1</h2>
        
        <div class="tag-cloud-container">
          <el-tag 
            v-for="tag in tags" 
            :key="tag.id" 
            :size="getTagSize(tag.id)"
            @click="goTag(tag.id)"
            class="tag-item"
          >
            {{ tag.name }}
            <span class="tag-count">{{ getArticleCount(tag.id) }}</span>
          </el-tag>
        </div>
      </div>

      <aside class="sidebar">
        <div class="sidebar-section">
          <h3>近期文章</h3>
          <ul class="recent-articles">
            <li v-for="article in recentArticles" :key="article.id">
              <a @click="goArticle(article.id)">{{ article.title }}</a>
            </li>
          </ul>
        </div>

        <div class="sidebar-section">
          <h3>博客分类</h3>
          <ul class="category-list">
            <li v-for="category in categories" :key="category.id">
              <a @click="goCategory(category.id)">{{ category.name }}</a>
            </li>
          </ul>
        </div>
      </aside>
    </main>

    <Footer />
  </div>
</template>

<script>
import BlogHeader from '@/components/BlogHeader.vue'
import Footer from '@/components/Footer/index.vue'
import { getTags, getCategories, getRecentArticles } from '@/api/blog'

export default {
  name: 'TagList',
  components: {
    BlogHeader,
    Footer
  },
  data() {
    return {
      tags: [],
      categories: [],
      recentArticles: [],
      tagCounts: {}
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const [tagsRes, categoriesRes, recentRes] = await Promise.all([
          getTags(),
          getCategories(),
          getRecentArticles()
        ])
        this.tags = tagsRes.data
        this.categories = categoriesRes.data
        this.recentArticles = recentRes.data
        
        this.tags.forEach(tag => {
          this.tagCounts[tag.id] = tag.articleCount || Math.floor(Math.random() * 30) + 1
        })
      } catch (error) {
        console.error('Failed to load data:', error)
      }
    },
    handleSearchFromHeader(keyword) {
      this.$router.push({ path: '/', query: { keyword } })
    },
    getArticleCount(tagId) {
      return this.tagCounts[tagId] || 0
    },
    getTagSize(tagId) {
      const count = this.getArticleCount(tagId)
      if (count >= 20) return 'large'
      if (count >= 10) return 'medium'
      return 'small'
    },
    goHome() {
      this.$router.push('/').catch(() => {})
    },
    goCategories() {
      this.$router.push('/categories').catch(() => {})
    },
    goTags() {
      this.$router.push('/tags').catch(() => {})
    },
    goTag(id) {
      this.$router.push({ path: '/', query: { tagId: id } })
    },
    goCategory(id) {
      this.$router.push({ path: '/', query: { categoryId: id } })
    },
    goArticle(id) {
      this.$router.push(`/article/${id}`)
    }
  }
}
</script>

<style scoped>
.tag-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  max-width: 1200px;
  margin: 2rem auto;
  display: flex;
  gap: 1.2rem;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
}

.tag-list-container {
  flex: 1;
  min-width: 0;
  width: 0; /* 配合 flex:1 强制撑满 */
}

.page-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1.2rem;
  background: #fff;
  padding: 15px 20px;
  border-radius: 8px;
}

.tag-cloud-container {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
}

.tag-item {
  padding: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.tag-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.tag-count {
  margin-left: 0.3rem;
  opacity: 0.7;
  font-size: 0.75em;
}

.sidebar {
  width: 280px;
  flex-shrink: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.sidebar-section {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.sidebar-section h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e5e7eb;
  color: #374151;
}

.recent-articles,
.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: 100%;
}

.recent-articles li,
.category-list li {
  margin-bottom: 0.75rem;
  width: 100%;
  max-width: 100%;
}

.recent-articles a,
.category-list a {
  color: #374151;
  text-decoration: none;
  font-size: 0.9rem;
  line-height: 1.4;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  max-width: 100%;
}

.recent-articles a:hover,
.category-list a:hover {
  color: #3b82f6;
}

.blog-footer {
  background: #0b193f;
  color: #9ca3af;
  text-align: center;
  padding: 1.5rem;
  margin-top: auto;
}

.blog-footer p {
  margin: 0;
  font-size: 0.875rem;
}

/* ========== 响应式屏幕适配 ========== */

/* 大屏幕 */
@media screen and (min-width: 1400px) {
  .main-content {
    max-width: 1200px;
  }
}

/* 中等屏幕 */
@media screen and (max-width: 1024px) {
  .main-content {
    gap: 1.5rem;
    padding: 0 1rem;
  }
  
  .sidebar {
    width: 260px;
  }
  
  .tag-cloud-container {
    padding: 20px;
    gap: 0.875rem;
  }
}

/* 平板：侧边栏移到下方，标签云在上方 */
@media screen and (max-width: 768px) {
  .main-content {
    flex-direction: column;
    gap: 1.5rem;
  }

  .sidebar {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    padding: 0;
  }

  .sidebar-section {
    margin-bottom: 0;
    padding: 0.85rem;
  }

  .sidebar-section h3 {
    font-size: 0.95rem;
    margin-bottom: 0.75rem;
    padding-bottom: 0.4rem;
  }

  .recent-articles li,
  .category-list li {
    margin-bottom: 0.6rem;
  }

  .recent-articles a,
  .category-list a {
    font-size: 0.85rem;
  }
  
  .tag-list-container {
    width: 100%;
  }
  
  .page-title {
    font-size: 1.2rem;
    padding: 12px 16px;
    margin-bottom: 1rem;
  }
  
  .tag-cloud-container {
    padding: 16px;
    gap: 0.75rem;
  }
}

/* 小平板（≤ 600px）侧边栏单列 */
@media screen and (max-width: 600px) {
  .sidebar {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

/* 手机 */
@media screen and (max-width: 576px) {
  .main-content {
    margin: 1rem auto;
    padding: 0 0.75rem;
    gap: 1rem;
  }
  
  .page-title {
    font-size: 1rem;
    padding: 10px 12px;
  }
  
  .tag-cloud-container {
    padding: 12px;
    gap: 0.5rem;
  }
  
  .tag-item {
    font-size: 12px !important;
  }
  
  .tag-count {
    font-size: 0.7em;
  }
  
  .sidebar-section {
    padding: 0.75rem;
  }
  
  .sidebar-section h3 {
    font-size: 0.9rem;
    margin-bottom: 0.75rem;
  }
  
  .recent-articles a,
  .category-list a {
    font-size: 0.85rem;
  }
}

/* 小手机 */
@media screen and (max-width: 375px) {
  .tag-cloud-container {
    padding: 10px;
    gap: 0.4rem;
  }
  
  .tag-item {
    font-size: 10px !important;
  }
}
</style>
